import urbanBike from "../../Images/urbanBike2.jpg";
import CTAButton from "../SHARED/CTAButton";
import { useLocation } from "react-router-dom";
import CTAButtonHash from "../SHARED/CTAButtonHash";

const KeyBenefitsOfMultiBikeCover = () => {
  const { search } = useLocation();
  return (
    <div className="container-fluid whiteBG oh">
      <div className="container mb-5">
        <div className="row pr">
          <div id="left" className="col-12 col-sm-8 pr oh pt-3">
            <h3 className="text-left pt-4 pb-4 mobileWidth">
              Key <span className="orangeFont">benefits</span> of our multi-bike
              cover.
            </h3>
            <p className="orangeFont">
              As keen cyclists ourselves, we understand how important it is to
              be completely covered without paying for unnecessary extras and it
              doesn't seem right to pay double or even triple the price when
              just one bike is actually being used at any one time.
            </p>
            <p>
              
              We understand that (most!) people can only ride one bike at a
              time.
            </p>

            <div className="row mb-5">
              <div className="col-6 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="84"
                  height="83"
                  viewBox="0 0 84 83"
                >
                  <defs>
                    <filter
                      id="Rectangle_1163"
                      x="5"
                      y="4"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1164"
                      x="0"
                      y="0"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_791"
                        data-name="Rectangle 791"
                        width="41.345"
                        height="25.293"
                        fill="#fff"
                      />
                    </clipPath>
                    <clipPath id="clip-path-2">
                      <rect
                        id="Rectangle_792"
                        data-name="Rectangle 792"
                        width="42.79"
                        height="26.031"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1163)"
                  >
                    <rect
                      id="Rectangle_1163-2"
                      data-name="Rectangle 1163"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(11 7)"
                      fill="rgba(255,145,0,0.3)"
                    />
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1164)"
                  >
                    <rect
                      id="Rectangle_1164-2"
                      data-name="Rectangle 1164"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#ff9100"
                    />
                  </g>
                  <g
                    id="Group_2067"
                    data-name="Group 2067"
                    transform="translate(-397.5 -1554.16)"
                  >
                    <g
                      id="Group_1754"
                      data-name="Group 1754"
                      transform="translate(412.833 1578.61)"
                      opacity="0.6"
                    >
                      <g
                        id="Group_1755"
                        data-name="Group 1755"
                        transform="translate(0 0)"
                        clipPath="url(#clip-path)"
                      >
                        <path
                          id="Path_2069"
                          data-name="Path 2069"
                          d="M49.065,15.278a1.888,1.888,0,0,0-.2.011l-2.1-7.283,0,0c-.006-.024-.009-.047-.017-.071L45.526,4.462l.968-.059h.018a3.1,3.1,0,0,1,.342-.008c.121,0,.243.011.363.024a3.575,3.575,0,0,1,.693.14,1.659,1.659,0,0,1,.991.714,1.578,1.578,0,0,1,.187.6,1.322,1.322,0,0,1-.09.607,1.363,1.363,0,0,1-.391.516,1.9,1.9,0,0,1-.291.2A1.979,1.979,0,0,1,48,7.334a.322.322,0,0,0,.071.637.335.335,0,0,0,.07-.008v.005a2.606,2.606,0,0,0,.469-.144,2.691,2.691,0,0,0,.432-.224,2.172,2.172,0,0,0,.71-.733,2.205,2.205,0,0,0,.288-1.014A2.714,2.714,0,0,0,50,5.336a2.4,2.4,0,0,0-.766-1.391,3.339,3.339,0,0,0-.861-.561,4.86,4.86,0,0,0-.922-.311c-.156-.036-.312-.066-.469-.09a4.552,4.552,0,0,0-.5-.049h0l-1.909-.117A.862.862,0,0,0,43.5,3.927l.53,1.508-12.292-1.8L31.31,1.917a2.509,2.509,0,0,1,2.062-.449c1.318.434,1.751.709,2.1.079,0,0,.078-1.356-2.654-1.317C30.768.259,27.87.089,26.556,0c-.434-.028-.687.25-.514.64.318.715,1.2,1.741,3.617,1.807L30.3,5.018l-.051.1-.418.779-.849,1.559L27.273,10.57l-2.659,4.8a1.864,1.864,0,1,0,1.177,2.366l6.085.674a2.527,2.527,0,0,0,4.806-1.534l8.586-7.961,2.79,6.657a1.858,1.858,0,1,0,1.007-.3m-14.474-.295L32.2,5.447,44.518,7.254,35.7,15.43a2.514,2.514,0,0,0-1.11-.447m-6.3-3.8L30.239,8.2l.623-.963,2.032,8.1a2.534,2.534,0,0,0-1.141,1.618l-5.878-.044a1.865,1.865,0,0,0-.531-1.088c-.02-.02-.043-.039-.064-.058Z"
                          transform="translate(-15.874 0)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2070"
                          data-name="Path 2070"
                          d="M46.164,39.659l-.379.58-.59.9a6.4,6.4,0,0,1,1.6,3.015l.633,0a3.77,3.77,0,0,1,.621-.857l-.457-1.821a8.162,8.162,0,0,0-1.3-1.7c-.04-.041-.083-.079-.123-.118"
                          transform="translate(-32.367 -28.403)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2071"
                          data-name="Path 2071"
                          d="M15.242,42.205l-1.078-.119A6.423,6.423,0,1,1,9.83,33.613l.525-.947.331-.6a8.153,8.153,0,1,0,5.053,10.747,3.718,3.718,0,0,1-.5-.605"
                          transform="translate(0 -22.675)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2072"
                          data-name="Path 2072"
                          d="M96.365,31.661c-.053,0-.106,0-.158,0a3.631,3.631,0,0,1-.524.148l-.043.009.455,1.577c.09,0,.18-.007.27-.007a6.424,6.424,0,1,1-4.543,1.881,6.509,6.509,0,0,1,.73-.627l-.425-1.015-3.292,3.053a8.155,8.155,0,1,0,7.53-5.022"
                          transform="translate(-63.174 -22.675)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_1755-2"
                      data-name="Group 1755"
                      transform="translate(418.225 1581.205)"
                    >
                      <g
                        id="Group_1757"
                        data-name="Group 1757"
                        transform="translate(0 0)"
                        clipPath="url(#clipPath-2)"
                      >
                        <path
                          id="Path_2073"
                          data-name="Path 2073"
                          d="M23.958,19.769a1.892,1.892,0,0,0,1.778-1.251l6.788.343a2.53,2.53,0,1,0,4.585-2.052l5.33-6.541a2.624,2.624,0,0,1,.244-.255,5.006,5.006,0,0,1,.529-.425A3.218,3.218,0,0,1,43.7,9.3l1.793-.8,1.047,2.555.123.3,2.528,5.11a1.9,1.9,0,1,0,.833-.425l-1.761-5.341s-.08-.192-.123-.3L45.125,3.033l1.757-.941a1.267,1.267,0,1,0-.3-.907l-2.706.574.005.014a.884.884,0,0,0-.183.051.865.865,0,0,0-.472,1.129l.732,1.785L32.177,9,30.525,4.692c.712-.563,1.229-1.193,2.171-1.1,1.381.133,1.864.307,2.071-.386,0,0-.223-1.341-2.88-.7-2,.481-4.861.952-6.162,1.157-.429.068-.616.4-.362.738.469.63,1.56,1.443,3.954.961l1.689,4.4L24.96,16.276a1.891,1.891,0,1,0-1,3.493m7.7-8.307,1.77,4.615a2.536,2.536,0,0,0-.906,1.269l-6.685.338a1.88,1.88,0,0,0-.284-.815Zm12.951-5.12.226.552-1.844.827a5.393,5.393,0,0,0-1.022.632c-.164.126-.322.259-.469.4a4.343,4.343,0,0,0-.406.428l-5.329,6.54a2.517,2.517,0,0,0-.83-.142c-.079,0-.158,0-.235.012L32.8,10.615Z"
                          transform="translate(-15.803 0)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2074"
                          data-name="Path 2074"
                          d="M50.966,50.5a8.121,8.121,0,0,0-.934-2.287l-1.324,1.173a6.376,6.376,0,0,1,.551,1.411l1.565-.079c.045-.074.092-.147.142-.218"
                          transform="translate(-34.883 -34.53)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2075"
                          data-name="Path 2075"
                          d="M8.155,50.567A8.151,8.151,0,0,0,16,44.646c-.02-.031-.041-.061-.059-.093l-1.7-.086a6.423,6.423,0,1,1-2.98-7.677l1.2-1.3A8.153,8.153,0,1,0,8.155,50.567"
                          transform="translate(0 -24.536)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2076"
                          data-name="Path 2076"
                          d="M107.222,36.648a8.158,8.158,0,0,0-6.972-2.3l.552,1.674a6.547,6.547,0,0,1,.654-.033,6.424,6.424,0,1,1-4.542,1.881c.093-.092.189-.181.287-.267l-.789-1.594a8.153,8.153,0,1,0,10.811.638"
                          transform="translate(-66.82 -24.536)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <p className="pr-3">
                  Multiple bike insurance quotes which consider the
                  reduced risk of incidences involving bikes left at home.
                </p>
              </div>
              <div className="col-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="84"
                  height="83"
                  viewBox="0 0 84 83"
                >
                  <defs>
                    <filter
                      id="Rectangle_1171"
                      x="5"
                      y="4"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1173"
                      x="0"
                      y="0"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path22">
                      <rect
                        id="Rectangle_789"
                        data-name="Rectangle 789"
                        width="50.516"
                        height="42.34"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1171)"
                  >
                    <rect
                      id="Rectangle_1171-2"
                      data-name="Rectangle 1171"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(11 7)"
                      fill="rgba(255,145,0,0.3)"
                    />
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1173)"
                  >
                    <rect
                      id="Rectangle_1173-2"
                      data-name="Rectangle 1173"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#ff9100"
                    />
                  </g>
                  <g
                    id="Group_2068"
                    data-name="Group 2068"
                    transform="translate(9.242 18.098)"
                  >
                    <g
                      id="Group_1751"
                      data-name="Group 1751"
                      transform="translate(5 -2)"
                      clipPath="url(#clip-path22)"
                    >
                      <path
                        id="Path_2060"
                        data-name="Path 2060"
                        d="M30.184,34.3a14.727,14.727,0,0,1,.838,3.945l.007.193H27.791l-.053-1.174c-.03-.34-.077-.674-.122-1.009a8.15,8.15,0,0,1-1.485.553c.042.372.078.746.1,1.125l.016.5H20.735l-.05-2.056a8.207,8.207,0,0,1-1.606-.95c.015.254.033.511.045.763l.055,2.243H13.431l.055-2.24c.046-.96.117-1.926.211-2.871l.111-.959.366.036c.726.046,1.549.061,2.445.038a8.132,8.132,0,0,1-.563-1.541l-.191,0c-.52,0-1.044-.017-1.6-.05l-.247-.022.014-.1c.126-.811.273-1.566.438-2.244a12.63,12.63,0,0,1,1.088-3.131c.335-.6.583-.759.652-.791l.1-.028.066.013a1.2,1.2,0,0,1,.408.385,8.266,8.266,0,0,1,1.371-1.844,16.311,16.311,0,0,0-1.852-.108L15.469,23A16.245,16.245,0,0,0,4.5,28.044l-.121.137-.118.05-.036.022a.842.842,0,0,0-.22.247l-.071.193-.425.491A16.123,16.123,0,0,0,0,39.284,16.293,16.293,0,0,0,15.474,55.57l.829.022h0A16.3,16.3,0,0,0,31.256,32.778,8.246,8.246,0,0,1,30.184,34.3M20.461,45.409c.094-.939.167-1.934.218-2.963l.058-2.465h5.514l-.019.666a19.565,19.565,0,0,1-1.321,6.095l-.272.619-.671-.257a22.131,22.131,0,0,0-3.032-.8l-.566-.089ZM19.185,39.98l-.061,2.4c-.043.949-.113,1.915-.208,2.868l-.085.75-1.215-.113c-.542-.038-1.115-.057-1.751-.057-.554,0-1.123.016-1.7.047l-.394.041-.075-.666c-.094-.94-.166-1.906-.211-2.866l-.058-2.4ZM14.022,24.934a15.358,15.358,0,0,0-1.064,3.193c-.163.669-.315,1.439-.465,2.358l-.024.183-1.24-.192a20.752,20.752,0,0,1-2.572-.643l.025-.049a10.438,10.438,0,0,1,5.34-4.851m-1.868,8.23c-.1.946-.17,1.942-.216,2.964l-.055,2.3H6.365l.016-.506a19.587,19.587,0,0,1,1.324-6.1l.257-.586.033.013a22.39,22.39,0,0,0,2.956.753l1.31.2Zm.077,12.911-1.285.2a22.77,22.77,0,0,0-2.957.751l-.13.049-.15-.338a19.743,19.743,0,0,1-1.329-6.09l-.021-.666h5.519l.06,2.469c.046,1.009.118,2,.216,2.962ZM6.133,28.61a14.66,14.66,0,0,1,3.138-2.292l.04-.02a14.36,14.36,0,0,0-1.62,2.133l-.483.876c-.388-.161-.755-.331-1.087-.5l-.112-.063ZM1.592,38.245a14.6,14.6,0,0,1,3.214-8.2l.121-.134.477.272c.4.2.755.363,1.121.517l-.4.92a21.61,21.61,0,0,0-1.253,5.639l-.05,1.169-3.233,0H1.585ZM4.755,48.46a14.634,14.634,0,0,1-3.162-8.127l-.014-.36,3.237.007.058,1.329a21.462,21.462,0,0,0,1.264,5.632l.295.679L5.4,48.1Zm4.524,3.8A14.673,14.673,0,0,1,6.14,49.971l-.309-.336.28-.158.978-.449.62,1.108a14.191,14.191,0,0,0,1.639,2.157Zm-.585-3.481-.155-.3a21.755,21.755,0,0,1,2.686-.681l1.2-.185.067.478c.149.907.3,1.677.464,2.352a15.492,15.492,0,0,0,1.065,3.189,10.514,10.514,0,0,1-5.329-4.856m9.454,1.31a12.852,12.852,0,0,1-1.091,3.125,1.867,1.867,0,0,1-.652.8l-.1.025-.073-.017c-.091-.041-.341-.2-.676-.806a12.387,12.387,0,0,1-1.087-3.125c-.165-.683-.312-1.437-.438-2.241l-.056-.39.286-.025c.51-.033,1.049-.051,1.6-.051.591,0,1.133.017,1.653.053l1.11.1-.047.308c-.122.783-.268,1.538-.432,2.244m.438,3.553a15.508,15.508,0,0,0,1.072-3.2c.166-.711.321-1.5.462-2.357l.044-.338.488.078a20.714,20.714,0,0,1,2.8.739l.491.189-.013.027a10.427,10.427,0,0,1-5.344,4.858m4.76-1.385-.051.024a14.27,14.27,0,0,0,1.625-2.137l.435-.783.5.24.618.37a14.784,14.784,0,0,1-3.131,2.285m7.676-11.927a14.654,14.654,0,0,1-3.213,8.2l-.26.281-.952-.566-.553-.265.44-1.024a21.522,21.522,0,0,0,1.253-5.639l.06-1.33h3.236Z"
                        transform="translate(0 -13.252)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2061"
                        data-name="Path 2061"
                        d="M68.762,8.922a6.339,6.339,0,0,0-2.486.507l-.049.023-.782-3.833,1.014-.279a.753.753,0,0,0,.486-.408L67.7,3.36a.765.765,0,0,0-.316-.995L63.323.1a.764.764,0,0,0-.585-.064.747.747,0,0,0-.45.361.762.762,0,0,0,.293,1.038L64.84,2.694,62.761,2a.761.761,0,0,0-.585.041.751.751,0,0,0-.381.435.768.768,0,0,0,.477.969l2.4.807-.315.086a.763.763,0,0,0-.546.888l.2.959-8.378,1.8L55.08,6.042l.023,0a5.785,5.785,0,0,0,1.372-.172.763.763,0,0,0-.37-1.481,3.943,3.943,0,0,1-2.192-.061,7.4,7.4,0,0,1-2.086-1.1.745.745,0,0,0-.568-.129.761.761,0,0,0-.312,1.372,8.823,8.823,0,0,0,2.476,1.3L53.906,7.5l-1.7,2.236L52.149,9.7A6.387,6.387,0,1,0,55.2,17.2l.037-.144,1.238.169L58.61,19.46l-.358.4a.766.766,0,0,0,.547,1.269.764.764,0,0,0,.6-.257L61.06,18.99a.763.763,0,1,0-1.144-1.011l-.3.336L58.181,16.8l6.563-6.991.079.382a.665.665,0,0,0,.029.108l-.6.495a6.382,6.382,0,1,0,4.513-1.874m-3.049-5.7c-.011-.021-.021-.041-.033-.06l.333.186-.292.609-.05.014a.8.8,0,0,0,.08-.166.757.757,0,0,0-.038-.583M53.583,17.2a4.861,4.861,0,1,1-4.48-6.753,4.766,4.766,0,0,1,1.878.379l.282.153-3.015,3.976a.764.764,0,0,0,.5,1.22l4.943.671Zm.377-1.855-3.71-.506,2.265-2.987.025.02a4.833,4.833,0,0,1,1.426,3.42Zm1.6-1.3a.747.747,0,0,0-.237-.161l-.122-.475a6.436,6.436,0,0,0-1.6-2.623l-.172-.142.994-1.307,1.407,5Zm2.085,1.1-1.6-5.687,8.267-1.78.062.305Zm11.117,5.024a4.862,4.862,0,0,1-3.448-8.285l.264-.217.332.609-.26.208A4.7,4.7,0,0,0,64.6,14a.76.76,0,0,0,.392,1.006.87.87,0,0,0,.292.066.771.771,0,0,0,.711-.458,3.183,3.183,0,0,1,.658-.978L67.98,16.1a.77.77,0,0,0,.64.4.715.715,0,0,0,.1-.006.781.781,0,0,0,.286-.088.762.762,0,0,0,.31-1.033l-1.392-2.563a.773.773,0,0,0,.265-.923.763.763,0,0,0-.423-.41.749.749,0,0,0-.562,0l-.346-.64.008,0a4.8,4.8,0,0,1,1.891-.386,4.86,4.86,0,1,1,0,9.72"
                        transform="translate(-24.633 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2062"
                        data-name="Path 2062"
                        d="M51.593,27.687a.754.754,0,0,0-.006-.588.745.745,0,0,0-.406-.408.761.761,0,0,0-.588,0,4.77,4.77,0,0,0-2.6,2.519.77.77,0,0,0,.682,1.071H48.7a.751.751,0,0,0,.694-.457A3.258,3.258,0,0,1,51.184,28.1a.743.743,0,0,0,.41-.41"
                        transform="translate(-27.636 -15.357)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>

                <p className="pr-3">
                  Comprehensive cover designed to meet the needs of all
                  multi-bike owners, with sports cover and worldwide cover
                  included as standard.
                </p>
              </div>
              <div className="col-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="84"
                  height="83"
                  viewBox="0 0 84 83"
                >
                  <defs>
                    <filter
                      id="Rectangle_1168"
                      x="5"
                      y="4"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1169"
                      x="0"
                      y="0"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clipPath1111">
                      <rect
                        id="Rectangle_790"
                        data-name="Rectangle 790"
                        width="48.016"
                        height="28.173"
                        transform="translate(0 0)"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1168)"
                  >
                    <rect
                      id="Rectangle_1168-2"
                      data-name="Rectangle 1168"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(11 7)"
                      fill="rgba(255,145,0,0.3)"
                    />
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1169)"
                  >
                    <rect
                      id="Rectangle_1169-2"
                      data-name="Rectangle 1169"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#ff9100"
                    />
                  </g>
                  <g
                    id="Group_1753"
                    data-name="Group 1753"
                    transform="translate(15.742 22.414)"
                  >
                    <g
                      id="Group_1753-2"
                      data-name="Group 1753"
                      transform="translate(0 0)"
                      clipPath="url(#clip-path1111)"
                    >
                      <path
                        id="Path_2063"
                        data-name="Path 2063"
                        d="M103.21,15.76c.009.026.022.049.033.075l.344.968.073.173.037.087c.007.018.01.022.02.05l.032.085,2.263,3.97c-.027.024-.055.048-.081.074a1.932,1.932,0,1,0,1.368-.567,1.906,1.906,0,0,0-.413.045l-1.574-4.147,0,0-.009-.039-.023-.092-.045-.183-.322-1.061L102.071,6.62l4.183-.179h.043a4.229,4.229,0,0,1,.58,0,4.664,4.664,0,0,1,.59.072,3.176,3.176,0,0,1,1.059.382,1.918,1.918,0,0,1,.718.741,2.425,2.425,0,0,1,.263,1.062,2.026,2.026,0,0,1-.258,1.049,1.921,1.921,0,0,1-.789.75,2.271,2.271,0,0,1-1.118.244,2.824,2.824,0,0,1-.748-.128.425.425,0,0,0-.531.161c-.1.2.092.425.246.488a3.569,3.569,0,0,0,.98.245,3.088,3.088,0,0,0,1.536-.229,2.841,2.841,0,0,0,1.233-1.021,3.035,3.035,0,0,0,.5-1.534,3.716,3.716,0,0,0-.048-.8,3.245,3.245,0,0,0-.234-.786,3.116,3.116,0,0,0-1.062-1.278,4.451,4.451,0,0,0-1.447-.651,6.141,6.141,0,0,0-.753-.146,5.641,5.641,0,0,0-.781-.05h0l-5.293-.14v0a.885.885,0,0,0-.991.89v.007a.883.883,0,0,0,.047.275h0l1.185,3.573h-6.93v1.8h6.976l-6.976,8.262v2.785l8.033-9.514Z"
                        transform="translate(-67.747 -3.499)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2064"
                        data-name="Path 2064"
                        d="M125.02,40.341a8.441,8.441,0,0,0-5.985-2.479,8.529,8.529,0,0,0-1.388.115l.191.575.332,1.092.017.069a6.761,6.761,0,0,1,.849-.056,6.668,6.668,0,1,1-4.715,1.953c.029-.029.059-.056.088-.084l-.047-.083-.067-.178-.126-.3-.334-.941a1.559,1.559,0,0,1-.062-.155l-.046-.137a8.632,8.632,0,0,0-.676.606,8.465,8.465,0,1,0,11.97,0"
                        transform="translate(-79.484 -27.217)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2065"
                        data-name="Path 2065"
                        d="M33.036,16.808a2.087,2.087,0,0,1,1.848-.5c1.277.4,1.7.679,2.016-.006,0,0,.022-1.446-2.589-1.287-1.963.119-4.741.061-6,.026a.463.463,0,0,0-.468.7c.334.752,1.224,1.818,3.582,1.767a2.7,2.7,0,0,0,.3-.062l1.044,2.655a21.039,21.039,0,0,0-4.321,4.079,20.429,20.429,0,0,0-1.763,2.606c-.189.334-.365.675-.534,1.019A2.012,2.012,0,1,0,27.6,30.478l10.047,1.895v0a.916.916,0,0,0,.3.022,5.423,5.423,0,0,0,2.2-.888c.088-.057.179-.119.27-.183V28.879a6.123,6.123,0,0,1-1.875,1.414c-.06.028-.116.052-.17.075l-3.657-9.3a21.527,21.527,0,0,1,5.7-2.2v-1.89a23.546,23.546,0,0,0-6.382,2.362Zm3.815,13.673-9.134-.865a2.011,2.011,0,0,0-.771-1.431c.182-.3.371-.588.57-.872A19.461,19.461,0,0,1,33.439,21.8Z"
                        transform="translate(-17.037 -10.787)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2066"
                        data-name="Path 2066"
                        d="M49.3,48.639a6.8,6.8,0,0,1,1.578,3.467l1.874.178A8.644,8.644,0,0,0,50.7,47.441a18.236,18.236,0,0,0-1.4,1.2"
                        transform="translate(-35.438 -34.103)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2067"
                        data-name="Path 2067"
                        d="M13.508,50.182a6.834,6.834,0,1,1-2.936-11.4Q11.2,38.013,11.9,37.3a8.674,8.674,0,1,0,4.854,11.22l-1.85-.349a6.852,6.852,0,0,1-1.394,2.014"
                        transform="translate(0 -26.365)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2068"
                        data-name="Path 2068"
                        d="M87.707.513a.532.532,0,0,0-1.062,0v23.8c0,1.1-.03,2.205,0,3.305,0,.015,0,.031,0,.046a.532.532,0,0,0,1.062,0V3.865c0-1.1.03-2.206,0-3.306,0-.015,0-.031,0-.046"
                        transform="translate(-62.275 0)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>

                <p className="pr-3">
                  Flexible multi bicycle insurance cover for various bike types
                  including road bikes, mountain bikes, triathlon bikes,
                  electric bikes and hybrid bikes.
                </p>
              </div>
              <div className="col-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="84"
                  height="83"
                  viewBox="0 0 84 83"
                >
                  <defs>
                    <filter
                      id="Rectangle_1170"
                      x="5"
                      y="4"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1172"
                      x="0"
                      y="0"
                      width="79"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path22222">
                      <rect
                        id="Rectangle_793"
                        data-name="Rectangle 793"
                        width="42.219"
                        height="38.371"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1170)"
                  >
                    <rect
                      id="Rectangle_1170-2"
                      data-name="Rectangle 1170"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(11 7)"
                      fill="rgba(255,145,0,0.3)"
                    />
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1172)"
                  >
                    <rect
                      id="Rectangle_1172-2"
                      data-name="Rectangle 1172"
                      width="67"
                      height="67"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#ff9100"
                    />
                  </g>
                  <g
                    id="Group_1758"
                    data-name="Group 1758"
                    transform="translate(18.641 17.314)"
                  >
                    <g
                      id="Group_1758-2"
                      data-name="Group 1758"
                      transform="translate(0 0)"
                      clipPath="url(#clip-path33333)"
                    >
                      <path
                        id="Path_2077"
                        data-name="Path 2077"
                        d="M38.606,14.65H36.9a15.837,15.837,0,0,0-31.585,0h-1.7A3.617,3.617,0,0,0,0,18.263v4.719A3.617,3.617,0,0,0,3.613,26.6H6.274a.988.988,0,0,0,.989-.989V15.639a.962.962,0,0,0-.01-.1,13.86,13.86,0,0,1,27.714,0,.961.961,0,0,0-.01.1v9.968a.988.988,0,0,0,.989.989H36.8v1.329a6.739,6.739,0,0,1-6.731,6.731H24.63a1.908,1.908,0,0,0-1.895-1.739H19.483a1.914,1.914,0,0,0-1.912,1.912v1.63a1.914,1.914,0,0,0,1.912,1.912h3.253a1.908,1.908,0,0,0,1.895-1.738h5.441a8.718,8.718,0,0,0,8.709-8.709V26.586a3.614,3.614,0,0,0,3.439-3.6V18.263a3.617,3.617,0,0,0-3.613-3.613M1.977,22.982V18.263a1.638,1.638,0,0,1,1.636-1.636H5.267v7.99H3.613a1.638,1.638,0,0,1-1.636-1.636M22.67,36.394H19.548v-1.5H22.67ZM40.241,22.982a1.638,1.638,0,0,1-1.636,1.636H36.952v-7.99h1.654a1.638,1.638,0,0,1,1.636,1.636Z"
                        transform="translate(0 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2078"
                        data-name="Path 2078"
                        d="M37.833,44.689a.791.791,0,0,0,1.318,0l2.018-3.044a9.739,9.739,0,1,0-5.354,0Zm-7.5-12.41a8.157,8.157,0,1,1,10.147,7.912.793.793,0,0,0-.467.331l-1.524,2.3-1.524-2.3a.792.792,0,0,0-.467-.331,8.142,8.142,0,0,1-6.166-7.912"
                        transform="translate(-17.383 -13.627)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2079"
                        data-name="Path 2079"
                        d="M62.788,47.115a1.208,1.208,0,1,0-1.208-1.208,1.209,1.209,0,0,0,1.208,1.208m0-1.582a.374.374,0,1,1-.374.374.374.374,0,0,1,.374-.374"
                        transform="translate(-37.228 -27.023)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2080"
                        data-name="Path 2080"
                        d="M51.534,47.115a1.208,1.208,0,1,0-1.208-1.208,1.209,1.209,0,0,0,1.208,1.208m0-1.582a.374.374,0,1,1-.374.374.374.374,0,0,1,.374-.374"
                        transform="translate(-30.425 -27.023)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2081"
                        data-name="Path 2081"
                        d="M40.279,44.7a1.208,1.208,0,1,0,1.208,1.208A1.21,1.21,0,0,0,40.279,44.7m0,1.582a.374.374,0,1,1,.374-.373.374.374,0,0,1-.374.373"
                        transform="translate(-23.62 -27.022)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>

                <p className="pr-3">An award-winning customer service team.</p>
              </div>
            </div>

            <div className="col-12 pb-3">
              <div className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 mb-sm-3 mb-3">
                  <CTAButton
                    align="left"
                    colour="green"
                    CTAText="Get a quote"
                    onClick={() => {
                      sessionStorage.removeItem("context");
                    }}
                    Url={`/get-a-quote${search}`}
                  />
                </div>
                {/* <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-3 negMarginMore">
                  <CTAButtonHash
                    align="left"
                    colour="blue"
                    CTAText="Compare our cover"
                    onClick={() => {
                      sessionStorage.removeItem("context");
                    }}
                    Url={`/bike-insurance-comparison-chart#chart`}
                  />
                </div> */}
              </div>
            </div>
          </div>
          <img
            src={urbanBike}
            className="KeyBensOrangeBike"
            alt="Orange urban bike"
          />
        </div>
      </div>
    </div>
  );
};

export default KeyBenefitsOfMultiBikeCover;
